module.exports = __webpack_public_path__ + "static/media/account_register_event_current.9b0871af.svg";